/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiPickersCalendarHeader to make it match the design system.
 *
 * See: https://mui.com/x/api/date-pickers/pickers-calendar-header/#classes
 */ export const MuiPickersCalendarHeader = {
    styleOverrides: {
        root: ({ theme })=>({
                borderBottom: `1px solid ${theme.palette.divider}`,
                marginBottom: 0,
                paddingBottom: '16px',
                position: 'relative',
                // forces arrows to be on either side of the month
                ['.MuiPickersArrowSwitcher-root']: {
                    display: 'flex',
                    position: 'absolute',
                    left: '8px',
                    right: '8px',
                    justifyContent: 'space-between'
                }
            }),
        labelContainer: {
            marginLeft: 'auto'
        },
        switchViewButton: {
            display: 'none'
        }
    }
};

//# sourceMappingURL=pickers-calendar-header-overrides.js.map